module.exports = "/images/assistance.jpg?7fb88a1d46f3b82a1c09959f914f60bf";